import { render } from "./InternshipCareer.vue?vue&type=template&id=fa378964&scoped=true&ts=true"
import script from "./InternshipCareer.vue?vue&type=script&lang=ts"
export * from "./InternshipCareer.vue?vue&type=script&lang=ts"

import "./InternshipCareer.vue?vue&type=style&index=0&id=fa378964&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa378964"]])

export default __exports__